<h1 mat-dialog-title>Record Info</h1>

<mat-dialog-content>
  <table class="border-collapse">
    <tbody>
      @for (record of records; track record) {
        <tr class="hover:bg-gray-200">
          <td class="p-1 text-right">
            <strong>{{ record.key }}:</strong>
          </td>
          <td class="p-1">{{ record.value }}</td>
        </tr>
      }
    </tbody>
  </table>
</mat-dialog-content>
